// extracted by mini-css-extract-plugin
module.exports = {"bookmarks":"Bookmarks_bookmarks__10Z4k"};